<template>
    <box>
        <template v-slot:header>
            <h4>{{resource('IOFormat_OverView_Header')}}</h4>
        </template>

        <template v-slot:body>
            <data-table 
                :columns="columns" 
                :data="formats" 
                :loading="loading" 
                class="table table-striped"

                @edit="editIoFormat($event.id)"
                @clone="formatToClone = $event.id"
                @copyId="copyToClipboard($event.id)"
            />
            <prompt
                v-if="formatToClone" 
                :title="resource('IOFormat_OverView_Clone_Prompt_Title')"
                :body="resource('IOFormat_OverView_Clone_Prompt_Body')"
                icon="fas fa-clone"

                @yes="cloneIoFormat(formatToClone)"
                @no="formatToClone = null"
            />
        </template>
    </box>
</template>

<script>

//Components
import DataTable, { defaultContentType } from '../../../Components/Util/DataTable/DataTable.vue';
import Box from '../../../Components/Util/BootstrapBox.vue';
import Prompt from '../../../Components/Util/Prompt.vue';

//Util
import _ from 'lodash';
import api, {endpoint} from '../api';
import {dateToString} from '../../../Util/time';
import { bootstrapDangerGrowl } from '../../../Util/growler';
import {copy} from '../../../Util/clipboard';
import moment from 'moment';

//Mixins
import resources from '../../../Util/Mixins/resources';
 import {autoInitializeTooltips as tooltips} from "../../../Util/Mixins/tooltips";

export default {
    name: 'overview',
    mixins: [resources, tooltips],
    components: {
        DataTable,
        Box,
        Prompt
    },
    created() {
        this.getFormats();
    },
    methods: {
        copyToClipboard(id) {
            copy(id);
        },
        getFormats() {
            this.loading = true;
            api.listIoFormats().then((formats) => {
                this.formats = formats;
                this.loading = false;
            },(error) => {
                this.loading = false;
                bootstrapDangerGrowl(error);
            })
        },
        createButton(outline, text, icon, tooltip) {
            const iconHtml = icon ? `<i class="${icon}"></i>` : '';
            const tooltipHtml = tooltip ? `data-toggle="tooltip" data-placement="top" title="${tooltip}"` : '';

            return `
                <button class="btn ${outline} btm-sm" ${tooltipHtml}>
                ${iconHtml}
                </button>`;
        },
        cloneIoFormat(id) {
            api.cloneIoFormat(id).then((format) => {
                window.location.href = `${endpoint}Edit/${id}`;
            }, bootstrapDangerGrowl);

            this.formatToClone = null;
        },
        editIoFormat(id) {
            window.location.href = `${endpoint}Edit/${id}`;
        }
    },
    computed: {
        columns() {
            const columns = [
                { title: '', data: 'id', visible: false },
                { title: this.resource('IOFormat_OverView_Column_Name_DisplayName'), data: 'name'},
                { 
                    title: this.resource('IOFormat_OverView_Column_Created_DisplayName'),
                    data: 'created',
                    render: function (data) {
                        if (data !== null) {
                            //Hack to make them sortable.
                            return `<span style="display:none">${moment(data).format()}</span> ${dateToString(data)}`;
                        }
                    }
                },
                { 
                    title: this.resource('IOFormat_OverView_Column_Modified_DisplayName'),
                    data: 'modified',
                    render: function (data) {
                        if (data !== null) {
                            //Hack to make them sortable.
                            return `<span style="display:none">${moment(data).format()}</span> ${dateToString(data)}`;
                        }
                    }
                },
                { title: this.resource('IOFormat_OverView_Column_CreatedBy_DisplayName'),  data: 'createdBy'},
                { 
                    title: this.resource('IOFormat_OverView_Column_Import_DisplayName'), 
                    data: 'import',
                    render: function (data) {
                        return data ? '<i class="fas fa-check display-icon"></i>' : '';
                    }
                },
                { 
                    title: this.resource('IOFormat_OverView_Column_Export_DisplayName'), 
                    data: 'export',
                    render: function (data) {
                        return data ? '<i class="fas fa-check display-icon"></i>' : '';
                    }
                }
            ];

            const editBtn = this.createButton(
                'btn-outline-secondary',
                '',
                'fas fa-pencil-alt',
                this.resource('IOFormat_Index_Submit_Edit_Button')
            );

            const cloneBtn = this.createButton(
                'btn-outline-secondary',
                '',
                'fas fa-clone',
                this.resource('IOFormat_Index_Submit_Clone_Button')
            );

            const copyBtn = this.createButton(
                'btn-outline-secondary',
                '',
                'fas fa-clipboard',
                this.resource('IoFormat_Copy_To_clipboard')
            );

            columns.unshift({
                name: 'copyId',
                data: null,
                defaultContent: copyBtn,
                type: defaultContentType.button,
                width: '30px',
                sClass: 'icon-button-padding', 
                orderable: false });

            columns.push({ 
                name: 'edit', 
                data: null, 
                defaultContent: editBtn, 
                type: defaultContentType.button, 
                width: '30px',
                sClass: 'icon-button-padding', 
                orderable: false });

            columns.push({ 
                name: 'clone', 
                data: null, 
                defaultContent: cloneBtn, 
                type: defaultContentType.button, 
                width: '30px', 
                sClass: 'icon-button-padding',
                orderable: false });

            return columns;
        }
    },
    data() {
        return {
            formatToClone: null,
            loading: false,
            formats: [],
            datatableOptions: { lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]] }
        };
    }
};
</script>